import { useCallback } from "react";

import AuthenticationTwoFactorChallengeForm from "../Authentication/TwoFactor/AuthenticationTwoFactorChallengeForm";

import { confirmPhoneNumber } from "../../mutations/ConfirmPhoneNumberMutation";
import { resendPhoneNumberCode } from "../../mutations/ResendPhoneNumberCodeMutation";

const PhoneNumberChangeChallengeStep = ({ onConfirmed }) => {
  const submitChallengeCode = useCallback(async formState => {
    const { confirmPhoneNumber: result } = await confirmPhoneNumber(formState);

    return result;
  }, []);

  const resendChallengeCode = useCallback(async () => {
    const { resendPhoneNumberCode: result } = await resendPhoneNumberCode();

    return result;
  }, []);

  return (
    <AuthenticationTwoFactorChallengeForm
      submitChallengeCode={submitChallengeCode}
      onConfirmed={onConfirmed}
      resendChallengeCode={resendChallengeCode}
    />
  );
};

export default PhoneNumberChangeChallengeStep;
